import React from "react";

export default () => {
  return (
    <>
      <h1>IKK Index page</h1>
    </>
  );
};
